import { render, staticRenderFns } from "./commodityDetails.vue?vue&type=template&id=d10170fe&scoped=true"
import script from "./commodityDetails.vue?vue&type=script&lang=js"
export * from "./commodityDetails.vue?vue&type=script&lang=js"
import style0 from "@/assets/font/pcFont/iconfont.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./commodityDetails.vue?vue&type=style&index=1&id=d10170fe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10170fe",
  null
  
)

export default component.exports